// Service types for gig platform
export interface ServiceType {
    value: 'remote' | 'onsite' | 'hybrid';
    label: string;
    description: string;
    icon: string;
}

export const SERVICE_TYPES: ServiceType[] = [
    {
        value: 'remote',
        label: 'Remote',
        description: 'Work can be done entirely online',
        icon: '🏠'
    },
    {
        value: 'onsite',
        label: 'On-site',
        description: 'Work must be done at a specific location',
        icon: '📍'
    },
    {
        value: 'hybrid',
        label: 'Hybrid',
        description: 'Combination of remote and on-site work',
        icon: '🔄'
    }
];

export const getServiceTypeLabel = (serviceType: 'remote' | 'onsite' | 'hybrid'): string => {
    const type = SERVICE_TYPES.find(t => t.value === serviceType);
    return type?.label || serviceType;
};

export const getServiceTypeIcon = (serviceType: 'remote' | 'onsite' | 'hybrid'): string => {
    const type = SERVICE_TYPES.find(t => t.value === serviceType);
    return type?.icon || '📍';
};